module.exports = __webpack_public_path__ + "img/20190629102654893.0e369ff3.png";